<template>
  <div>
    <van-popup
      v-model="show"
      class="full-height full-width"
      :close-on-popstate="true"
      position="right"
    >
      <ld-header @click-left="show = false">
        选择部门
      </ld-header>
      <van-search
        v-model.lazy="value"
        placeholder="请输入中文"
        shape="round"
      />
      <van-cell-group>
        <van-cell
          v-for="(department,index) in list"
          :key="index"
          :title="department.label"
          :value="department.deptNo"
          clickable
          @click="select(department)"
        />
      </van-cell-group>
    </van-popup>
  </div>
</template>

<script>
import { Search, Popup, Cell, CellGroup } from 'vant'

export default {
  name: 'LdDepartment',
  components: {
    [Popup.name]: Popup,
    [Search.name]: Search,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup
  },
  props: {
    corpId:''
  },
  data() {
    return {
      show: false,
      value: '',
      nationList: [],
      list:[]
    }
  },
  created() {
    const {corpId} = this
    this.$api['user/vipDeptTreeForEmpQr']({corpId}).then(res => {
      let cache=res.data||{}
      let list=cache||[]
      if(list.length>0){
        this.nationList=list
      }
    })
  },
  methods: {
    select (department) {
      this.show = false
      this.$emit('selected', department)
    },
    toggle() {
      this.show = !this.show
    }
  },
  watch:{
    value(val){
      if(val){
        const term = val.toUpperCase()
        this.list=this.nationList.filter(department => {
          return (
            department.label && department.label.indexOf(term) > -1
          )
        })
      }else{
        this.list=this.nationList
      }
    },
    'nationList.length'(){
      this.list=this.nationList
    }
  }
}
</script>

<style lang="less" scoped>
</style>
